import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { LegalInfoService } from '../services/legal-info.service';
import { Constants, Routes } from '../constants';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { LoaderService } from '../loader/loader.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PageTitleService } from '../services/page-title.service';
import { SessionStorageService } from '../services/session-storage.service';
import { AnnouncementModalService } from 'src/app/core/services/announcement-modal/announcement-modal.service';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
    selector: 'app-legal-info',
    templateUrl: './legal-info.component.html',
    styleUrls: ['./legal-info.component.scss'],
    standalone: false
})
export class LegalInfoComponent implements OnInit {

  public legalInfoType: string;
  LegalTypeContent: string;
  public errorMessage = '';
  public isError: boolean;
  public isPrivacyPolicyRead = true;
  public isTermsOfUseRead = true;
  public isClaims: boolean;
  legalInfoForm: UntypedFormGroup;
  public enableSave: boolean;
  public userType: string;

  constructor(private location: Location, private loader: LoaderService,
              private legalInfoService: LegalInfoService, private authenticationService: AuthenticationService,
              private readonly fb: UntypedFormBuilder, private readonly router: Router, public pageTitleService: PageTitleService,
              private sessionStorage: SessionStorageService, private annonceService: AnnouncementModalService,
              private dialogService: DialogService) {
    this.setLegalType();
    if (this.authenticationService.GetClaims()) {
      this.userType = this.authenticationService.GetLoggedInUserDetails().type.toLowerCase();
      if (this.userType !== Constants.INTERNAL_USER) {
        this.setPolicyAcceptanceDetails();
      }
    }
  }

  ngOnInit() {
    this.pageTitleService.title = this.legalInfoType;
    this.GenerateForm();
    this.isError = false;
    this.loader.show();
    const domainName = window.location.hostname;
    if (this.legalInfoType === Constants.PRIVACY_POLICY) {
      this.legalInfoService.getLatestPrivacyPolicy(domainName).subscribe({
        next: (data: string) => {
          if (data) {
            this.LegalTypeContent = data;
            this.loader.hide();
          } else {
            this.httpErrorHandling();
          }
        },
        error: () => {
          this.httpErrorHandling();
        }
      });
    } else {
      this.legalInfoService.getLatestTermsOfUse(domainName).subscribe({
        next: (data: string) => {
          if (data) {
            this.LegalTypeContent = data;
            this.loader.hide();
          } else {
            this.httpErrorHandling();
          }
        },
        error: () => {
          this.httpErrorHandling();
        }
      });
    }
  }

  private GenerateForm() {
    this.legalInfoForm = this.fb.group({
      acceptPolicy: [false, [Validators.required]],
    });
    this.legalInfoForm.controls.acceptPolicy.valueChanges.subscribe(state => {
      this.enableSave = state;
    });
  }

  private setLegalType() {
    if (this.location.path().includes(Routes.PRIVACY_POLICY_ROUTE)) {
      this.legalInfoType = Constants.PRIVACY_POLICY;
    } else {
      this.legalInfoType = Constants.TERMS_OF_USE;
    }
  }

  private setPolicyAcceptanceDetails() {
    const details = this.authenticationService.GetUserPolicyAcceptanceDetails();
    this.isPrivacyPolicyRead = details.isPrivacyPolicyRead;
    this.isTermsOfUseRead = details.isTermsOfUseRead;
  }

  private httpErrorHandling() {
    this.loader.hide();
    this.errorMessage = Constants.NO_CONTENT_INFO;
    this.isError = true;
  }

  public get claims() {
    return this.authenticationService.GetClaims();
  }


  public printType() {
   setTimeout(() => {
    window.print();
   }, 500);

  }
  Save() {
    this.loader.show();
    this.legalInfoService.UpdatePolicyDetail(this.authenticationService.GetLoggedInUserDetails().userId,
      this.legalInfoType.replace(/ /g, ''))
      .subscribe({
        next: () => {
          const details = this.authenticationService.GetUserPolicyAcceptanceDetails();
          if (this.legalInfoType === Constants.PRIVACY_POLICY) {
            details.isPrivacyPolicyRead = true;
          } else if (this.legalInfoType === Constants.TERMS_OF_USE) {
            details.isTermsOfUseRead = true;
          }
          this.authenticationService.SetUserPolicyAcceptanceDetails(details);
          this.loader.hide();
          if (this.sessionStorage.getItem('AccessionId')
            && this.authenticationService.GetLoggedInUserDetails().email === this.sessionStorage.getItem('Email')
            && this.userType.toLocaleLowerCase() !== Constants.INTERNAL_USER) {
            this.router.navigate([Constants.HOME_TAB], { replaceUrl: true });
          } else {
            this.sessionStorage.removeItem('AccessionId');
            this.router.navigate(['/']);
          }
        },
        error: () => {
          this.loader.hide();
        }
      });
  }

}
